import React from 'react';
import TableBoolean from '../../components/Table/TableBoolean/TableBoolean';

export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };    
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {
        dataField: 'instance',
        text: 'Instance',
        sort: true,
        headerStyle: () => { return { width: '100px', ...headerStyle() }; },
    },
    {
        dataField: 'active',
        text: 'Status',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.active} text={row.statusName} />,
        headerStyle: () => { return { width: '100px', ...headerStyle() }; }
    },
    {
        dataField: 'name',
        text: 'Instance Name',
        sort: true,
        headerStyle: () => { return { minWidth: '200px', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'demo',
        text: 'Demo',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.demo} />,
        headerStyle: () => { return { width: '80px', ...headerStyle() }; }
    },
    {
        dataField: 'corporateOwned',
        text: 'Corporate',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.corporateOwned} />,
        headerStyle: () => { return { width: '110px', ...headerStyle() }; }
    },
    {
        dataField: 'srn',
        text: 'SRN',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.srn} />,
        headerStyle: () => { return { width: '80px', ...headerStyle() }; }
    },
    {
        dataField: 'royaltyPlanTemplateId',
        text: 'Royalty Plan',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={(row.royaltyPlanTemplateId) ? 1 : 0} />,
        headerStyle: () => { return { width: '125px', ...headerStyle() }; }
    },
    {
        dataField: 'city',
        text: 'City',
        sort: true,
        headerStyle: () => { return { width: '150px', ...headerStyle() }; }
    },
    {
        dataField: 'stateName',
        text: 'State',
        sort: true,
        headerStyle: () => { return { width: '130px', ...headerStyle() }; }
    }
];

export const sorting = [{
    dataField: 'instance',
    order: 'asc'
}];